import jsurl from 'jsurl';

const QueryParser = {}

function encode(obj) {
	// Depth first
	Object.keys(obj).forEach(key => {
		let current = obj[key];
		
		if (current instanceof Date) {
			let val = current.getTime();
			obj[key] = {
				type: 'date',
				value: val
			}
		} else if (current instanceof Array) {
			for (var i = 0; i < current.length; i++) {
				obj[key] = encode(obj[key]);
			}
		} else if (current instanceof Object) {
			return encode(obj[key]);
		} 
	})
	
	return obj;
}


function decode(obj) {
    let keys = Object.keys(obj);
	if (keys.length === 2 && keys.includes("value") && keys.includes("type")) {
		// We need to substitute for the correct val
		if (obj["type"] === 'date') {
			obj = new Date(obj['value'])
		}
	}
	
	Object.keys(obj).forEach(key => {
		if (obj[key] instanceof Object) {	
			obj[key] = decode(obj[key]);
		}
	})
	
	return obj;
}



QueryParser.install = function(Vue, options) {
    Vue.prototype.$encode = (payload) => {
        // Traverse the OBJ and modify it in such a way that no dates are left
        let finalPayload = encode(payload);

        return jsurl.stringify(finalPayload);
    }


    Vue.prototype.$parse = (queryObj) => {
        // First decode
        let parsed = jsurl.parse(queryObj);

        let decoded = decode(parsed);

        return decoded;

    }
}

export default QueryParser;